import { defineMessages } from 'react-intl';

export default defineMessages({
  leader: {
    id: 'app.components.UserListItem.leader',
    defaultMessage: 'Leader',
  },
  vip: {
    id: 'app.components.UserListItem.vip',
    defaultMessage: 'VIP',
  },
  hasCarAvailable: {
    id: 'app.components.UserListItem.hasCarAvailable',
    defaultMessage: 'has a car available for this shift',
  },
  isShiftLeader: {
    id: 'app.components.UserListItem.isShiftLeader',
    defaultMessage: 'can be assigned as team lead',
  },
  assignmentIsVisible: {
    id: 'app.components.UserListItem.assignmentIsVisible',
    defaultMessage: 'knows about this assignment',
  },
});
